import React, { memo } from 'react'
import { Grid, Stack } from '@mui/material'
import { faGift } from '@fortawesome/pro-light-svg-icons'

import DisplayStats from './DisplayStats'
import CustomButton from '../shared/buttons/CustomButton'
import HeadingWithHelpText from '../shared/text/HeadingWithHelpText'
import LabelValue from '../shared/text/LabelValue'
import { formatOrdinal, formatPts } from '../../util/numbers.helpers'
import { MIN_ETH_TO_REDEEM_POINTS } from '../../constants/app'

const RedeemPoints = ({
  t,
  onRedeemPoints,
  mainProfile: {
    points,
    finalPoints,
    timeBasedPointsFinal,
    timeBasedPositionFinal,
    individualPoints,
    amountBasedPointsFinal,
    amountBasedPositionFinal,
    rank,
    referralBasedPointsFinal,
    referralBasedPositionFinal,
    communityPoints,
    communityRank,
    saleClaimed,
    resultUserDeposit
  },
  stakingProfile: { claimedStake }
}) => {
  const depositReceivedData = [
    {
      label: t('results.time-based'),
      points: timeBasedPointsFinal,
      desc: t('results.points-wallet-to-deposit', {
        position: formatOrdinal(timeBasedPositionFinal)
      })
    },
    {
      label: t('results.amount-based'),
      points: amountBasedPointsFinal,
      desc: t('results.first-wallet-to-deposit', {
        position: amountBasedPositionFinal
      })
    },
    {
      label: t('results.referral-bonus'),
      points: referralBasedPointsFinal,
      desc: t('results.referral-first-wallet', {
        label:
          referralBasedPointsFinal === 0
            ? t('results.not-first-wallet')
            : t('results.referred-wallets', {
                position: referralBasedPositionFinal
              })
      })
    },
    {
      label: t('results.individual-ranking-bonus'),
      points: individualPoints,
      desc: t('results.place-ranking', {
        position: formatOrdinal(rank)
      })
    },
    {
      label: t('results.community-ranking-bonus'),
      points: communityPoints,
      desc: t('results.place-community', {
        position: formatOrdinal(communityRank)
      })
    }
  ]
  return (
    <Grid container spacing={0}>
      <Grid item xs={12} sm={6}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <DisplayStats
              data={[
                {
                  label: t('home.total-deposit-points-earned'),
                  helpText: t('home.total-deposit-points-help-text'),
                  value: formatPts(points + finalPoints)
                }
              ]}
              gridSize={12}
              descStyles={{
                fontWeight: 900,
                sx: {
                  fontSize: '2.625rem'
                }
              }}
            />
          </Grid>
          <Grid item xs={12}>
            {resultUserDeposit >= MIN_ETH_TO_REDEEM_POINTS && (
              <CustomButton
                onClick={onRedeemPoints}
                icon={faGift}
                label={t('staking.redeem-points')}
                disabled={!(points > 0) || saleClaimed || claimedStake}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Stack spacing={1}>
          <HeadingWithHelpText
            label={t('results.deposit-points-received')}
            helpText={t('results.deposit-points-received-help')}
          />
          <Stack spacing={0.3125}>
            {depositReceivedData.map(({ label, points, desc }, index) => (
              <LabelValue
                key={index}
                fontSize={0.875}
                label={label}
                value={
                  <>
                    {formatPts(points)}
                    {points > 0 ? ` ${desc}` : ''}
                  </>
                }
                valueProps={points === 0 && { color: '' }}
              />
            ))}
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  )
}

export default memo(RedeemPoints)
